export default "__VITE_ASSET__B163uiUM__"